
			<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container">
          <a routerLink="/principal" class="navbar-brand"><img src="assets/images/lhb.png" alt="homepage" class="light-logo" />
            <img src="assets/images/lhtextow.png" class="light-logo" alt="homepage" /></a>

          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarNav">

            <ul class="navbar-nav ml-auto">

                <li class="nav-item">
                  <a class="nav-link" routerLink="/principal">Inicio</a>
              </li>
            </ul>
        </div>

      </div>
      </nav>
<body>
  <div class="col-lg-6 mx-auto m-t-20">
    <div class="card bbb_deals">
      <button (click)="regresarPagina()" style="width: 100px; height: 30px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
      <div class="card-body">
        <form [formGroup]="formularioEnviarMensaje" (ngSubmit)="crearMensaje()" class="form p-t-20">
          <div class="row">
            <div class="col-md-12">

              <h2>Contáctate con el administrador</h2><br>
              <div class="form-group row">

                <div class="form-group col-12">
                  <label for="titulo">Título del mensaje</label>
                  <input formControlName="titulo" placeholder="Ejm.: Recuperar cuenta" class="form-control input-sm" type="text" required minlength="5" maxlength="100">
                  <span class="bar"></span>

                  <div class="alert-danger" *ngIf="titulo.invalid && (titulo.dirty || titulo.touched)" >
                    <div class="container-error-message" *ngIf="titulo.errors.required" >
                      El titulo es requerido
                    </div>
                    <div class="container-error-message" *ngIf="titulo.errors.minlength" >
                      El titulo debe tener mínimo 5 caracteres
                    </div>
                    <div class="container-error-message" *ngIf="titulo.errors.maxlength">
                      El titulo debe tener máximo 100 caracteres
                    </div>
                  </div>

                </div>

                <div class="col-md-12 form-group">
                  <label for="asunto">Asunto del mensaje</label>
                  <div class="input-group">
                    <div class="input-group-addon"></div>
                    <textarea formControlName="asunto" type="text" required minlength="5" maxlength="250" class="form-control"
                      aria-label="With textarea"></textarea>
                  </div>

                  <div class="alert-danger" *ngIf="asunto.invalid && (asunto.dirty || asunto.touched)" >
                    <div class="container-error-message" *ngIf="asunto.errors.required" >
                      El asunto es requerido
                    </div>
                    <div class="container-error-message" *ngIf="asunto.errors.minlength" >
                      El asunto debe tener mínimo 5 caracteres
                    </div>
                    <div class="container-error-message" *ngIf="asunto.errors.maxlength">
                      El asunto debe tener máximo 250 caracteres
                    </div>
                  </div>

                </div>

                <div class="form-group col-12">
                  <label for="correo">Escribe tu correo</label>
                  <input formControlName="correo" placeholder="Ejm.: correo@gmail.com" class="form-control input-sm" type="text" required email minlength="5" maxlength="30">
                  <span class="bar"></span>

                  <div class="alert-danger" *ngIf="correo.invalid && (correo.dirty || correo.touched)" >
                    <div class="container-error-message" *ngIf="correo.errors.required" >
                      El correo es requerido
                    </div>
                    <div class="container-error-message" *ngIf="correo.errors.minlength">
                      El correo debe tener mínimo 5 caracteres
                    </div>
                    <div class="container-error-message" *ngIf="(correo.dirty || correo.touched) && correo.invalid && correo.errors.pattern">
                      Debe ser un correo válido
                    </div>
                    <div class="container-error-message" *ngIf="correo.errors.maxlength">
                      El correo debe tener máximo 30 caracteres
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
          <div class="form-group text-center">
            <div class="col-xs-12">
              <button class="btn btn-block btn-lg btn-info btn-rounded" [disabled]="!formularioEnviarMensaje.valid" type="submit">
                Enviar mensaje
              </button>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</body>
